import React, { useState } from 'react';
import dayjs from 'dayjs';
import { NewsArticleModel } from '../../../../core/apiSchema';
import Loader from '../../../../components/Loader/Loader';
import TagsCell from '../../../../components/DataTable/TagsCell/TagsCell';
import { Tag } from '../../../../core/models/Tag';
import './NewsArchiveList.styles.scss';

interface iNewsArchiveListProps {
    data: NewsArticleModel[];
    onItemClick: (item: NewsArticleModel) => void;
    isLoading?: boolean;
}

const NewsArchiveList: React.FC<iNewsArchiveListProps> = ({ data, onItemClick, isLoading }) => {
    const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set());

    const toggleRowExpansion = (id: number) => {
        setExpandedRows((prev) => {
            const next = new Set(prev);
            if (next.has(id)) {
                next.delete(id);
            } else {
                next.add(id);
            }
            return next;
        });
    };

    if (isLoading && data.length === 0) {
        return (
            <div className="NewsArchiveList">
                <div className="NewsArchiveList__loader">
                    <Loader />
                </div>
            </div>
        );
    }

    if (!isLoading && data.length === 0) {
        return <div className="NewsArchiveList__empty">No results found</div>;
    }

    return (
        <div className="NewsArchiveList">
            {data.map((article) => (
                <div key={article.id} className="NewsArchiveList__card" onClick={() => onItemClick(article)}>
                    <div className="NewsArchiveList__body">
                        <div className="NewsArchiveList__thumbnail">
                            <img src={article.featuredImage || ''} alt={article.title || ''} className="NewsArchiveList__image" />
                        </div>
                        <div className="NewsArchiveList__content">
                            <span className="NewsArchiveList__title">{article.title}</span>
                            <div className="NewsArchiveList__meta">
                                <span className="NewsArchiveList__date">
                                    {article.publishedDate ? dayjs(article.publishedDate).format('MMMM D, YYYY') : ''}
                                </span>
                            </div>
                        </div>
                    </div>
                    {article.tags && article.tags.length > 0 && (
                        <div className="NewsArchiveList__tags">
                            <TagsCell
                                rowId={article.id ?? 0}
                                tags={article.tags.map((tag, i) => new Tag({ apiModel: { id: i, value: tag } }))}
                                isExpanded={expandedRows.has(article.id ?? 0)}
                                toggleRowExpansion={toggleRowExpansion}
                            />
                        </div>
                    )}
                </div>
            ))}
            {isLoading && data.length > 0 && (
                <div className="NewsArchiveList__loader">
                    <Loader />
                </div>
            )}
        </div>
    );
};

export default NewsArchiveList;
